import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InterviewConversation from '../components/interview/InterviewConversation';

/**
 * Dedicated-page shell for the interview — the "sustained session" surface (design §12).
 * Used for first-run onboarding and the dashboard "continue at length" path.
 */
const InterviewPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const entryMode = params.get('mode') === 'now' ? 'now' : 'backfill';

  return (
    <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ px: 3, py: 2, borderBottom: '1px solid #e5e7eb', bgcolor: 'white',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#111827' }}>
            {entryMode === 'now' ? 'What are you working on now?' : 'Build your profile'}
          </Typography>
          <Typography variant="caption" sx={{ color: '#6b7280' }}>
            A calm, ~5-minute conversation. We capture the shape first; depth comes later.
          </Typography>
        </Box>
        <IconButton onClick={() => navigate('/')} aria-label="Close"><CloseIcon /></IconButton>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <InterviewConversation variant="page" entryMode={entryMode} />
      </Box>
    </Box>
  );
};

export default InterviewPage;
